import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "種類",
    isNumber: true,
  },
];

export const ThreeHighDiseaseAnalysis = {
  label: "三高疾病分析",
  key: "ThreeHighDiseaseAnalysis",
  path: "HealthCenterHealthCheckup/ThreeHighDiseaseAnalysis",
  api: "TCS_V_HCCS05",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.ThreeHighDiseaseAnalysis {...options} />
  ),
  isColSum: true,
  isPercent: true,
  isGroup: true,
  groupColumns: [
    {
      key: "是否異常",
      field: "是否異常",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
